import { httpClient } from "../_helpers";

export const locationService = {
  getByServicePartnerId,
  getCollectionSites,
};

function getByServicePartnerId(id) {
  return httpClient
    .get(`/site/servicepartner/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

function getCollectionSites(id) {
  return httpClient
    .get(`/site/collectionsites/${id}`)
    .then((response) => {
      var arr = response.data;
      // var obj = arr.reduce(function(acc, cur, i) {
      //     acc[cur.serviceSiteId] = cur.name;

      //     return acc;
      //   }, {});
      return arr;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
